<template>
    <!-- Meta Tags -->
    <Head :title="`${recipe.name} - Chokis`" />

    <section
        class="bg-[#061991] w-full min-h-screenheaderfooter flex flex-col justify-center items-center bg-heart-orange-mobile md:bg-heart-orange bg-top bg-cover md:bg-bottom bg-no-repeat"
    >
        <div class="container py-8 md:py-12">
            <nav class="flex mb-8" aria-label="Breadcrumb">
                <ol class="inline-flex items-center space-x-1 md:space-x-2">
                    <li class="inline-flex items-center">
                        <Link
                            href="/"
                            class="inline-flex items-center text-sm font-medium text-white hover:text-orange hover:underline"
                        >
                            <svg
                                aria-hidden="true"
                                class="w-4 h-4 mr-2"
                                fill="currentColor"
                                viewBox="0 0 20 20"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z"
                                ></path>
                            </svg>
                            Inicio
                        </Link>
                    </li>
                    <li class="inline-flex items-center">
                        <Link
                            href="/recetas"
                            class="inline-flex items-center text-sm font-medium text-white hover:text-orange hover:underline"
                        >
                            <svg
                                aria-hidden="true"
                                class="w-6 h-6 text-white"
                                fill="currentColor"
                                viewBox="0 0 20 20"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    fill-rule="evenodd"
                                    d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                                    clip-rule="evenodd"
                                ></path>
                            </svg>
                            Recetas
                        </Link>
                    </li>
                    <li aria-current="page">
                        <div class="flex items-center">
                            <svg
                                aria-hidden="true"
                                class="w-6 h-6 text-white"
                                fill="currentColor"
                                viewBox="0 0 20 20"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    fill-rule="evenodd"
                                    d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                                    clip-rule="evenodd"
                                ></path>
                            </svg>
                            <span class="ml-1 text-sm font-bold md:ml-2">{{ recipe.name }}</span>
                        </div>
                    </li>
                </ol>
            </nav>

            <div class="md:flex justify-center items-start md:space-x-4" id="main-content">
                <div class="w-full mb-4 md:w-1/2 md:mb-0">
                    <div class="video-responsive rounded-2xl overflow-hidden">
                        <iframe
                            :src="`https://www.youtube.com/embed/${recipe.video_url}`"
                            title="YouTube video player"
                            frameborder="0"
                            class="bg-black w-full h-full"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowfullscreen
                        >
                        </iframe>
                    </div>
                </div>
                <div class="w-full flex flex-col justify-center items-start md:w-1/2 md:flex-row">
                    <div class="w-full space-y-4">
                        <h1 class="text-orange text-3xl leading-9 font-bold pr-2">
                            {{ recipe.name }}
                        </h1>
                        <h2 class="text-lg">
                            <strong>Categoría:</strong>
                            <span class="font-helvetica ml-2">
                                {{ recipe.category }}
                            </span>
                        </h2>
                        <div class="flex justify-start items-end space-x-4">
                            <div class="text-gray text-lg space-x-2">
                                <font-awesome-icon icon="fa-regular fa-bowl-hot" />
                                <span class="text-lg">{{ recipe.difficulty }}</span>
                            </div>
                            <div class="text-gray text-lg space-x-2">
                                <font-awesome-icon icon="fa-solid fa-user" />
                                <span class="text-lg">{{ recipe.portions }}</span>
                            </div>
                            <!-- <div class="text-gray text-xl space-x-2">
                                <font-awesome-icon icon="fa-regular fa-clock-three" />
                                <span class="text-lg"></span>
                            </div> -->
                        </div>
                        <div class="font-helvetica">
                            {{ recipe.short_description }}
                        </div>
                        <Link
                            href="/donde-comprar"
                            target="_blank"
                            class="font-bold bg-white text-blue rounded-md w-60 h-10 flex justify-center items-center transition-all hover:bg-opacity-80"
                        >
                            Comprar productos
                        </Link>
                    </div>
                    <div
                        class="hidden w-full flex justify-start items-center md:flex-col space-x-2 md:w-auto md:flex-1 md:space-x-0 md:space-y-2"
                    >
                        <p class="text-blue">Compartir:</p>
                        <div class="flex justify-center items-center space-x-2 md:flex-col md:space-x-0 md:space-y-2">
                            <ShareNetwork
                                network="WhatsApp"
                                :url="`/recetas/`"
                                class="text-blue text-2xl hover:text-orange"
                            >
                                <font-awesome-icon icon="fa-brands fa-whatsapp" />
                            </ShareNetwork>
                            <ShareNetwork
                                network="facebook"
                                :url="`/recetas/`"
                                class="text-blue text-2xl hover:text-orange"
                            >
                                <font-awesome-icon icon="fa-brands fa-facebook" />
                            </ShareNetwork>
                        </div>
                    </div>
                </div>
            </div>

            <div class="my-8">
                <div class="">
                    <strong>Receta hecha con: </strong>
                    {{ product.name }}
                </div>
                <img
                    class="w-60 mt-4"
                    :src="getImageName(product.image)"
                    :alt="product.name"
                />
            </div>

            <div
                class="w-full my-4 space-y-4 flex flex-col justify-center items-center md:flex-row md:items-start md:space-y-0 md:space-x-4"
            >
                <div class="w-full space-y-4 md:w-1/2">
                    <div class="">
                        <h2 class="font-bold mb-4">Ingredientes:</h2>
                        <div class="content-list" v-html="recipe.ingredients"></div>
                    </div>
                </div>
                <div class="w-full md:w-1/2">
                    <h2 class="font-bold mb-4">PASOS</h2>
                    <div class="content-list" v-html="recipe.steps"></div>
                </div>
            </div>
        </div>

        <div class="w-full bg-recipesRelated bg-cover">
            <div class="container my-16">
                <h2 class="text-orange font-bold text-3xl text-center mt-8 md:text-4xl mb-8">Recetas Relacionadas</h2>
                <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 lg:gap-8 max-w-5xl mx-auto">
                    <article
                        v-for="(related_recipe, index) in related_recipes"
                        :key="index"
                        v-if="related_recipes.length"
                        class="w-full rounded-2xl overflow-hidden"
                    >
                        <div class="w-full h-auto flex justify-center items-center">
                            <img
                                class="w-full h-auto bg-center"
                                :src="
                                    related_recipe.thumbnail
                                        ? `/storage/recipes/${related_recipe.thumbnail}`
                                        : `https://img.youtube.com/vi/${related_recipe.video_url}/mqdefault.jpg`
                                "
                                :alt="related_recipe.name"
                            />
                        </div>
                        <div class="bg-pink w-full h-32 space-y-2 p-4 flex flex-col justify-between items-start">
                            <p class="text-sm md:text-base">
                                {{ related_recipe.name }}
                            </p>
                            <div class="w-full flex justify-between items-center space-x-1">
                                <span class="text-[14px]">
                                    {{ related_recipe.difficulty }}
                                </span>
                                <!-- <span class="text-[14px]">10 min</span> -->
                                <span class="text-[14px]">{{ related_recipe.portions }} </span>
                                <Link :href="`/recetas/${related_recipe.slug}`" class="text-sm btn-white shrink-0"
                                    >Ver Receta</Link
                                >
                            </div>
                        </div>
                    </article>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import { Navigation, Pagination, A11y } from "swiper";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
export default {
    name: "Show",
    components: {
        Swiper,
        SwiperSlide,
    },
    props: ["recipe", "related_recipes", "product"],
    data() {
        return {
            modules: [Navigation, Pagination, A11y],
        };
    },
    methods: {
        getImageName(image) {
            return image.replace('public/products', '/storage/products');
        }
    },
    mounted() {},
};
</script>
<style></style>